import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/Modal'; // Ensure you created this component
import './Contact.css';

const Contact = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        // Prevent default form refresh
        e.preventDefault();
        
        // Open our high-end custom modal instead of a browser alert
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        // Redirect the user back to the home page after they acknowledge the message
        navigate("/");
    };

    return (
        <div className="contact-page">
            <div className="contact-container">
                <div className="contact-header">
                    <span className="gold-tag">Project Inquiry</span>
                    <h1>Begin Your Build.</h1>
                    <p>Schedule a consultation with our strategy team.</p>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Full Name</label>
                        <input 
                            type="text" 
                            placeholder="e.g. Alexander Hamilton" 
                            required 
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Corporate Email</label>
                        <input 
                            type="email" 
                            placeholder="name@company.com" 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Service Interest</label>
                        <select required>
                            <option value="">Select a service...</option>
                            <option>The Foundation</option>
                            <option>The Pillar</option>
                            <option>The Monument</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Project Brief</label>
                        <textarea 
                            placeholder="Tell us about your objectives..." 
                            rows="5" 
                            required
                        ></textarea>
                    </div>

                    <button type="submit" className="submit-btn">SUBMIT INQUIRY</button>
                </form>
            </div>

            {/* Custom Modal Component */}
            <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
        </div>
    );
};

export default Contact;